import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-accent", className)}
      {...props}
    />
  )
}

function TableLoader() {
  return (
    <div className="flex flex-col w-full gap-2 pt-14">
      {Array(5).fill(null).map((_, i) => (
        <Skeleton key={i} className="h-16" />
      ))}
    </div>
  )
}

export { Skeleton, TableLoader }
